import FullScreenSystem from './containers/FullScreenSystem'

export default FullScreenSystem
